export default __webpack_public_path__ + "static/media/i (29).d5b69ddc.jpg";